import { Box, useTheme } from "@mui/material";
import DataGrid, {
  FilterRow,
  HeaderFilter,
  Column,
  SortByGroupSummaryInfo,
  Paging,
  Pager,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import Button from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";

import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataGridConfig } from "../../../config";
import FilterBox from "./filter";
import { reportGrievanceFun6, setFilter } from "../../../store/reducers/report";
import moment from "moment";

const GrievanceReport6List = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const grievanceList6 = useSelector((state) => state.report.grievanceList6);
  const filter = useSelector((state) => state.report.filter);

  const [showFilterRow, setShowFilterRow] = useState(true);
  const [showHeaderFilter, setShowHeaderFilter] = useState(true);
  const [currentFilter, setCurrentFilter] = useState("full");
  const [formData, setFormData] = useState([]);

  const gridRef = useRef();

  const allowedPageSizes = [5, 10, "Бүгд"];

  const setFilters = (field, value) => {
    dispatch(setFilter({ ...filter, [field]: value }));
  };

  // Load data
  useEffect(() => {
    if (grievanceList6 == null) {
      dispatch(
        reportGrievanceFun6({
          ...filter,
          start_date: moment().startOf("year").format("YYYY-MM-DD"),
          end_date: moment().format("YYYY-MM-DD"),
        })
      );
    } else {
      setFormData(grievanceList6);
    }
  }, [grievanceList6, filter, dispatch]);

  useEffect(() => {
    if (Object.keys(filter).length > 0) {
      dispatch(reportGrievanceFun6(filter));
    }
  }, [filter, dispatch]);

  // Dynamic columns
  const dynamicColumns =
    grievanceList6?.header?.map((h) => ({
      dataField: `type_${h.id}`,
      caption: h.name,
      dataType: "number",
      alignment: "center",
    })) ?? [];

  // Dynamic summary items
  const dynamicSummaryItems =
    grievanceList6?.header?.map((h) => ({
      column: `type_${h.id}`,
      summaryType: "sum",
      displayFormat: "{0}",
    })) ?? [];

  return (
    <>
      <Toolbar style={{ paddingBottom: "10px" }}>
        <Item location="before">
          <Box sx={{ ml: 2 }}>
            <FilterBox getFilters={setFilters} />
          </Box>
        </Item>
      </Toolbar>

      <Toolbar>
        <Item location="before">
          <Box sx={{ ml: 2 }}>
            <Button
              icon={"refresh"}
              onClick={() => {
                gridRef.current.instance.refresh();
              }}
              type={"normal"}
              text="Сэргээх"
            />
          </Box>
        </Item>

        <Item location="after">
          <Box>
            <Button
              onClick={() => {
                gridRef.current.instance.exportToExcel();
              }}
            >
              <Box sx={{ background: "#fff", p: 0.5 }}>
                <img src="/assets/excel.png" alt="" className="dx-icon" />
              </Box>
            </Button>
          </Box>
        </Item>
      </Toolbar>

      <DataGrid
        ref={gridRef}
        {...DataGridConfig}
        remoteOperations={false}
        dataSource={formData?.data ?? []}
        selection={false}
        id="gridContainer"
        wordWrapEnabled={true}
        height={600}
      >
        <FilterRow visible={showFilterRow} applyFilter={currentFilter} />
        <HeaderFilter visible={showHeaderFilter} />

        <Paging defaultPageSize={50} />
        <Pager
          visible={true}
          allowedPageSizes={allowedPageSizes}
          displayMode="full"
          showPageSizeSelector={true}
          showInfo={true}
          showNavigationButtons={true}
        />

        <Column
          caption="#"
          width={60}
          alignment="center"
          fixed={true}
          cellRender={(e) => e.rowIndex + 1}
        />

        <Column
          dataField="company_name"
          caption="Аж ахуйн нэгж, байгууллагын нэр"
          width={250}
        />

        <Column caption={"Мэдээлэл"} alignment={"center"}>
          {dynamicColumns.map((col) => (
            <Column key={col.dataField} {...col} />
          ))}

          <Column
            dataField="total"
            caption="НИЙТ"
            width={120}
            alignment="center"
          />
        </Column>
        {/* SUMMARY — DYNAMIC + TOTAL */}
        <Summary>
          <TotalItem
            column="company_name"
            summaryType="sum"
            customizeText={() => "Нийт дүн"}
          />
          {dynamicSummaryItems.map((s) => (
            <TotalItem key={s.column} {...s} />
          ))}

          <TotalItem column="total" summaryType="sum" displayFormat="{0}" />
        </Summary>

        <SortByGroupSummaryInfo summaryItem={0} />
      </DataGrid>
    </>
  );
};

export default GrievanceReport6List;
